// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"s_bZ ml-3","matrix-table--pad4":"s_b0 ml-5","matrix-table__title":"s_b1","matrix-table__true":"s_b2","matrix-table__false":"s_b3"};